module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/bench/bench.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/bench/bench.png
// module id = 517
// module chunks = 0